(function () {
  /* NOTE:
		This factory is for the calndar and distribution options

		This factory contains
		- selectedDate
		- currentDate
		- selectedProduct
		- options
		- functions for checking the criteria
		- function to extract distribution options
	*/
  'use strict';

  function distributionFactory (Common, apiFactory, $rootScope) {
    const factory = {};
    const deliveryClass = {
      'information': {
        '100': 'wt-box-normal',
        '200': 'wt-box-1class',
        '300': 'wt-box-economy'
      },
      'DKLetters': {
        '100': 'wt-box-blue-1class',
        '200': 'wt-box-blue-economys',
        '300': 'wt-box-blue-1class',
        '400': 'wt-box-blue-economy'
      },
      'paymentSlips': {
        '100': 'wt-box-normal',
        '200': 'wt-box-1class',
        '300': 'wt-box-economy'
      },
      'admail-letter': {
        '100': 'wt-box-blue-1class',
        '300': 'wt-box-blue-economy'
      },
      'admail-postcard': {
        '100': 'wt-box-blue-1class',
        '300': 'wt-box-blue-economy'
      }
    };

    const deliveryColors = {
      'information': {
        '100': 'do-1st-class',
        '200': 'do-1st-class-express',
        '300': 'do-economy'
      },
      'admail-letter': {
        '100': 'do-blue-1st-class',
        '200': 'do-blue-1st-class-express',
        '300': 'do-blue-economy'
      },
      'admail-postcard': {
        '100': 'do-blue-1st-class',
        '200': 'do-blue-1st-class-express',
        '300': 'do-blue-economy'
      },
      'DKLetters': {
        '100': 'do-blue-1st-class',
        '200': 'do-blue-1st-class-express',
        '300': 'do-blue-economy',
        '400': 'do-blue-1st-class'
      },
    };

    let isCurrentDayLastDayOfWeek = false;
    let daysToStartFromCurrent = 1;


    factory.years = [];

    function getHolidays (country, language, year) {
      const data = {
        'country': country,
        'language': language,
        'year': (year || '').toString()
      };

      return apiFactory.getHolidays.post(data).$promise;
    }

    function getTimeRemaining (time, currentHr, currentMin) {
      const currentSeconds = moment.duration(currentHr + ':' + currentMin, 'HH:mm').asSeconds();
      const timeSeconds = moment.duration(time, 'HH:mm').asSeconds();
      let timeRemaining = timeSeconds - currentSeconds;

      timeRemaining = moment('1900-01-01 00:00:00').add(timeRemaining, 'seconds').format('HH:mm').split(':');
      timeRemaining = timeRemaining[0] + 'h ' + timeRemaining[1] + 'm';

      return timeRemaining;
    }

    function getTime (time) {
      const currentHr = moment().hours();
      const currentMin = moment().minutes();
      let timeRemaining = '00h 00m';

      if (parseInt(time.split(':')[0]) > currentHr) {
        timeRemaining = getTimeRemaining(time, currentHr, currentMin);
      }

      return timeRemaining;
    }

    function getCalendarDates () {
      return factory.calendarDates;
    }


    function checkIfHoliday (date) {
      return (factory.holidays || []).filter(function (item) {
        return moment(date).isSame(item.date, 'day');
      });
    }


    function checkIfOnWeekend (date) {
      return date.getDay() === 0 || date.getDay() === 6;
    }

    function plotOptionDays (options) {
      const plotDates = factory.getCalendarDates();

      factory.calendarDates = options.map(function (item) {
        const date = {
          'date': moment().businessAdd(item.deliveryDays[0].start),
          'class': deliveryColors[Common.get('serviceType', 'information')][item.id]
        };

        return date;
      });

      factory.calendarDates = factory.calendarDates.concat(plotDates);

    }

    function setCurrentDate (range, id, cb) {
      let daysCnt = 0;
      let x;
      const product = Common.get('productDelivery', false);
      const serviceType = Common.get('serviceType');

      if (!range && product) {
        range = product.pricingInfo.deliveryOptions.deliveryDays.range;
      }

      factory.currentDate = moment();
      factory.calendarDates = [{
        'date': factory.currentDate,
        'class': 'dp-current-date'
      }];

      if (factory.selectedDate && range && id) {
        for (x = 0; daysCnt < range; x++) {
          const date = new Date(angular.copy(factory.selectedDate));
          const op = {
            0: date.getDate() - x,
            1: date.getDate() + x
          };

          date.setDate(op[Number(serviceType === 'DKLetters')]);
          if (!checkIfOnWeekend(date) && !checkIfHoliday(date).length) {
            factory.calendarDates.push({
              'date': date,
              'class': deliveryColors[Common.get('serviceType', 'admail')][id]
            });

            daysCnt++;
          }

        }

        cb();
      }
    }

    function getCurrentDate () {
      return factory.currentDate;
    }

    function addYear (year) {
      factory.years.push(year);
    }

    function filterYear (item) {
      return item === this.year;
    }

    function checkDateRange (range, selectedDate) {
      const currentDay = moment(factory.currentDate);
      let x, date;
      let validDate = true;
      let daysCnt = 0;

      for (x = 0; daysCnt < range; x++) {
        date = new Date(angular.copy(selectedDate));
        date.setDate(date.getDate() - x);
        if (!checkIfOnWeekend(date) && !checkIfHoliday(date).length) {
          validDate = moment(date).isAfter(currentDay);
          if (!validDate) {
            break;
          }

          daysCnt++;
        }
      }

      return validDate;
    }

    function checkDateValidityForAdmail (date) {
      let validDate = false;
      const validOptions = factory.deliveryOptions;

      if (validOptions.length) {
        validOptions.forEach(function (option) {
          validDate = option.deliveryDays.filter(function (delivery) {
            return checkDateRange(delivery.range, date);
          }).filter(function (delivery) {
            return !delivery.invalidOption;
          }).length;
        });
      }

      return validDate;
    }

    function checkTime (day) {
      return day.time ? getTime(day.time) === '00h 00m' : false;
    }

    function filterOptionsToSelectDate () {
      let options = [];

      factory.deliveryOptions.forEach(function (item) {
        options = item.deliveryDays.filter(function (day) {
          return checkTime(day);
        });
      });

      return !options.length;
    }

    // NOTE: this is for admail. there are just small changes from the checkIfLastDayOfWeek but i think its better to
    // have this separated just in case there are other conditions for admail
    function checkIfLastDayOfWeekAdmail (currentDate) {
      let isHoliday;
      const day = currentDate.getDay();
      const dateCpy = angular.copy(currentDate);
      let x = 1;
      let checked = false;

      if (day < 5 && day !== 0) {
        for (x; dateCpy.getDay() < 6; x++) {
          dateCpy.setDate(dateCpy.getDate() + x);
          isHoliday = checkIfHoliday(dateCpy).length;
          if (isHoliday && dateCpy.getDay() === 5 && !checked) {
            isCurrentDayLastDayOfWeek = true;
            checked = true;
          }

          if (!isHoliday && dateCpy.getDay() !== 0 && !checked) {
            daysToStartFromCurrent = x;
            break;
          }
        }
      }
    }

    //  this function is for checking the day if the succeeding days until friday are holidays
    function checkIfLastDayOfWeek (currentDate) {
      let isHoliday;
      const day = currentDate.getDay();
      const dateCpy = angular.copy(currentDate);
      let x = 1;
      let checked = false;
      const daysLimit = {
        0: 5,
        1: 6
      };

      if (day < 5 && day !== 0) {
        for (x; dateCpy.getDay() < 6; x++) {
          dateCpy.setDate(dateCpy.getDate() + x);
          isHoliday = checkIfHoliday(dateCpy).length;
          if (isHoliday && dateCpy.getDay() === 5 && !checked) {
            isCurrentDayLastDayOfWeek = true;
            checked = true;
          }

          if (!isHoliday && dateCpy.getDay() < daysLimit[Number($rootScope.isNCP)] && dateCpy.getDay() !== 0
            && !checked) {
            daysToStartFromCurrent = x;
            break;
          }
        }
      }
    }

    function startPreselectDKLetterSettings (currentDate) {
      let x, date, dateOnAWeekend, filteredDay, daysToSelected, startDateIsSet;
      let daysToStart = angular.copy(daysToStartFromCurrent);
      const currentDateOnWeekend = checkIfOnWeekend(currentDate);

      for (x = daysToStart; ; x++) {
        date = angular.copy(currentDate);
        date.setDate(date.getDate() + x);
        dateOnAWeekend = checkIfOnWeekend(date);
        filteredDay = checkIfHoliday(date).length;
        factory.selectedDate = date;
        factory.getDeliveryOptions(false, x, startDateIsSet).length;

        if (!filteredDay && !dateOnAWeekend) {
          if (!startDateIsSet) {
            daysToStart = angular.copy(x);
            startDateIsSet = true;
          }

          if (filterOptionsToSelectDate()
            && ((!currentDateOnWeekend && startDateIsSet)
              || (currentDateOnWeekend && startDateIsSet && x !== daysToStart))) {
            daysToSelected = angular.copy(x);
            break;
          }
        }
      }

      return {
        daysToStart: daysToStart,
        daysToSelected: daysToSelected
      };
    }

    function startPreSelectAdmailSettings (currentDate) {
      // this is for admail products
      let x, date, dateOnAWeekend, filteredDay, startDateIsSet, daysToSelected, validSelectedDate;
      let daysToStart = angular.copy(daysToStartFromCurrent);

      for (x = daysToStart; ; x++) {
        date = angular.copy(currentDate);
        date.setDate(date.getDate() + x);
        dateOnAWeekend = checkIfOnWeekend(date);
        filteredDay = checkIfHoliday(date).length;
        factory.selectedDate = date;
        validSelectedDate = true;

        if (!filteredDay && !dateOnAWeekend) {
          // check if the start of the selectable date is already set
          if (!startDateIsSet) {
            daysToStart = angular.copy(x);
            startDateIsSet = true;
          } else {
            factory.getDeliveryOptions(false, daysToStart);

            if (filterOptionsToSelectDate()) {
              if (!checkDateValidityForAdmail(angular.copy(date))) {
                validSelectedDate = false;
              }

              if (validSelectedDate) {
                daysToSelected = angular.copy(x);
                break;
              }
            }
          }
        }
      }

      return {
        daysToStart: daysToStart,
        daysToSelected: daysToSelected
      };
    }

    function startPreSelectSettings (currentDate) {
      // this method is for  ebrev products
      let x, skipped, date, dateOnAWeekend, filteredDay, startDateIsSet, daysToSelected, curDateOnAWeekend,
        curDateOnHoliday;
      let daysToStart = angular.copy(daysToStartFromCurrent);

      for (x = daysToStart; ; x++) {
        date = angular.copy(currentDate);
        curDateOnAWeekend = checkIfOnWeekend(currentDate);
        date.setDate(date.getDate() + x);
        dateOnAWeekend = checkIfOnWeekend(date);
        filteredDay = checkIfHoliday(date).length;
        curDateOnHoliday = checkIfHoliday(currentDate).length;
        factory.selectedDate = date;

        if (!filteredDay && !dateOnAWeekend) {
          // case: when current day is a holiday or on a weekend
          if (!startDateIsSet) {
            if ((curDateOnAWeekend || curDateOnHoliday) && !skipped) {
              skipped = true;
            } else {
              daysToStart = angular.copy(x);
              startDateIsSet = true;

              if (factory.getDeliveryOptions(false, daysToStart).length) {
                daysToSelected = angular.copy(x);
                break;
              }
            }
          } else {
            factory.getDeliveryOptions(false, daysToStart);

            if (filterOptionsToSelectDate()) {
              daysToSelected = angular.copy(x);
              break;
            }
          }
        }
      }

      return {
        daysToStart: daysToStart,
        daysToSelected: daysToSelected
      };

    }

    function getStartEndDate (start, currentDate) {
      let onWeekend, onHoliday, startDate;
      let daysToStart = 0;
      let x = 0;

      if (currentDate.getDay() === 5 && !$rootScope.isNCP) {
        x = 1;
      }

      x = isCurrentDayLastDayOfWeek ? x + 1 : x;

      for (x; daysToStart < start; x++) {
        startDate = angular.copy(currentDate);
        startDate.setDate(startDate.getDate() + x);

        onWeekend = checkIfOnWeekend(startDate);
        onHoliday = checkIfHoliday(startDate);

        if (!onWeekend && !onHoliday.length && x > 0) {
          daysToStart++;
        }

        if (daysToStart === start) {
          break;
        }
      }

      return moment(startDate);
    }


    function filterByDaysAdmail (item) {
      // this is for filtering options for admail
      // NOTE: there are commented logs in this method. this is for debuggin purposes.
      const deliveryDaysArr = [];
      let startDate, endDate, selectedDateFormatted, startDateFormatted;
      const currentDay = moment();
      const curIsHoliday = checkIfHoliday(currentDay).length;
      const triggeredBySelection = this.triggeredBySelection;

      item.deliveryDays.forEach(function (option) {
        let pushToArray = false;

        startDate = getStartEndDate(option.start, new Date());
        endDate = angular.copy(startDate);

        if (option.end && option.start === option.end) {
          endDate = getStartEndDate(option.end, new Date());
        }
        // console.log('selectedDate ' + moment(factory.selectedDate).format('MM-DD-YYYY'))
        selectedDateFormatted = moment(factory.selectedDate).format('MM-DD-YYYY');
        startDateFormatted = startDate.format('MM-DD-YYYY');
        // console.log('startDateFormatted ' + startDateFormatted)

        if (!option.end && (moment(factory.selectedDate).isAfter(startDate))
          || startDateFormatted === selectedDateFormatted) {
          // uncomment this log for debugging purposes
          // console.log('1-admail')
          pushToArray = true;
        }

        if (option.end && (option.start === option.end) && (selectedDateFormatted === startDateFormatted)) {
          // uncomment this log for debugging purposes
          // console.log('3-admail ' + selectedDateFormatted + ' ' + startDateFormatted)
          pushToArray = true;
        }

        if (option.end && (option.start !== option.end) && moment(factory.selectedDate).isBetween(startDate, endDate)) {
          // uncomment this log for debugging purposes
          // console.log('4-admail')
          pushToArray = true;
        }

        // Show Enabled economy option
        if (option.start === 4 && (selectedDateFormatted === startDateFormatted
          || moment(factory.selectedDate).isSame(startDate))) {
          // uncomment this log for debugging purposes
          // console.log('6-admail')
          option.invalidOption = false;
          pushToArray = true;
        }

        if (option.range && !checkDateRange(option.range, factory.selectedDate) && triggeredBySelection) {
          // uncomment this log for debugging purposes
          // console.log('8-admail')
          pushToArray = false;
        }

        if ((currentDay.day() === 6 || currentDay.day() === 0) && option.time) {
          // uncomment this log for debugging purposes
          // console.log('10-admail')
          pushToArray = false;
        }

        if (curIsHoliday && currentDay.day() !== 0 && currentDay.day() !== 6 && option.time) {
          // uncomment this log for debugging purposes
          // console.log('11-admail')
          pushToArray = false;
        }

        if (pushToArray) {
          deliveryDaysArr.push(option);
        }

      });

      item.deliveryDays = deliveryDaysArr;

      return item.deliveryDays.length;
    }

    function filterByDays (item) {
      // NOTE: there are commented logs in this method. this is for debuggin purposes.
      const deliveryDaysArr = [];
      let startDate, endDate, selectedDateFormatted, startDateFormatted, threeDaysDate, threeDaysDateFormatted;
      const currentDay = moment();
      const curIsHoliday = checkIfHoliday(currentDay).length;
      const triggeredBySelection = this.triggeredBySelection;
      const numberOfRecipients = parseInt(Common.get('recipients.validAddressCount', 0));
      const lateLimit = item.additionalServices ? item.additionalServices.find(item => item.lateLimit).lateLimit : null;

      item.deliveryDays.forEach(function (option) {
        let pushToArray = false;
        threeDaysDate = moment().businessAdd(3);
        startDate = getStartEndDate(option.start, new Date());

        if (option.end) {
          endDate = getStartEndDate(option.end, new Date());
        }
        // console.log('selectedDate ' + moment(factory.selectedDate).format('MM-DD-YYYY'))
        selectedDateFormatted = moment(factory.selectedDate).format('MM-DD-YYYY');
        startDateFormatted = startDate.format('MM-DD-YYYY');
        // console.log('startDateFormatted ' + startDateFormatted)
        threeDaysDateFormatted = threeDaysDate.format('MM-DD-YYYY');

        if ((option.end === null || angular.isUndefined(option.end)) && (selectedDateFormatted === startDateFormatted
          || moment(factory.selectedDate).isAfter(startDate))) {
          // uncomment this log for debugging purposes
          // console.log('1')
          pushToArray = true;
        }

        if (option.end && (option.start === option.end) && (selectedDateFormatted === startDateFormatted)) {
          // uncomment this log for debugging purposes
          // console.log('2 ' + selectedDateFormatted + ' ' + startDateFormatted)
          pushToArray = true;
        }

        if (option.end && (option.start !== option.end) && moment(factory.selectedDate).isBetween(startDate, endDate)) {
          // uncomment this log for debugging purposes
          // console.log('3')
          pushToArray = true;
        }

        // Show Economy expired economy option before start day except on the 3rd day
        if (option.start === 4 && (selectedDateFormatted === startDateFormatted
          || moment(factory.selectedDate).isBefore(startDate))
          && !(moment(selectedDateFormatted).isSame(threeDaysDateFormatted))) {
          // uncomment this log for debugging purposes
          // console.log('4')
          option.invalidOption = true;
          pushToArray = true;
        }

        // Show Enabled economy option
        if (option.start === 4 && (selectedDateFormatted === startDateFormatted
          || moment(factory.selectedDate).isSame(startDate))) {
          // console.log('5')
          option.invalidOption = false;
          pushToArray = true;
        }

        if (option.range && !checkDateRange(option.range, factory.selectedDate) && triggeredBySelection) {
          // uncomment this log for debugging purposes
          // console.log('7')
          pushToArray = false;
        }

        if (currentDay.day() === 5 && curIsHoliday && option.time) {
          // uncomment this log for debugging purposes
          // console.log('8')
          pushToArray = false;
        }

        if ((currentDay.day() === 6 || currentDay.day() === 0) && option.time) {
          // uncomment this log for debugging purposes
          // console.log('9')
          pushToArray = false;
        }

        if (curIsHoliday && currentDay.day() !== 0 && currentDay.day() !== 6 && option.time) {
          // uncomment this log for debugging purposes
          // console.log('10')
          pushToArray = false;
        }

        if (lateLimit && numberOfRecipients > lateLimit.max) {
          pushToArray = false;
        }

        if (pushToArray) {
          deliveryDaysArr.push(option);
        }

      });

      item.deliveryDays = deliveryDaysArr;

      return item.deliveryDays.length;

    }

    function filterByDelivery (item) {
      return item.deliveryDays.length;
    }

    function filterByAddressType (item) {
      if (!item.addressType) {
        return true;
      }
      return item.addressType === Common.get('addressType', 'ADR');
    }

    function filterEmptyPostage (item) {
      return item.postageProducts.length;
    }

    function appendDeliveryClass (item) {
      item.class = deliveryClass[Common.get('serviceType', getInformationCategory())][item.id];

      return item;
    }

    // NOTE: this is only for testing purposes!!!
    // this can be helpful when debugging something in the delivery option
    // function changeTime (item) {
    //   item.deliveryDays = item.deliveryDays.map((day) => {
    //     if (day.time) {
    //       if (day.time === '9:00') {
    //         day.time = '6:00';
    //       } else {
    //         day.time = '24:00';
    //       }
    //     }
    //     return day;
    //   });

    //   return item;
    // }

    // have a separate function for DK letters just in case there are other requirements for displaying options.
    function filterByDaysDKLetters (item) {
      // NOTE: there are commented logs in this method. this is for debuggin purposes.
      const deliveryDaysArr = [];
      let startDate, endDate, selectedDateFormatted, startDateFormatted;
      const currentDay = moment();
      const curIsHoliday = checkIfHoliday(currentDay).length;
      const curIsWeekend = checkIfOnWeekend(new Date(currentDay));
      const triggeredBySelection = this.triggeredBySelection;

      item.deliveryDays.forEach(function (option) {
        const startDays = curIsHoliday || curIsWeekend ? option.start + 1 : option.start;
        let pushToArray = false;

        startDate = getStartEndDate(startDays, new Date());
        endDate = angular.copy(startDate);

        if (option.end && option.start === option.end) {
          endDate = getStartEndDate(startDays, new Date());
        }

        selectedDateFormatted = moment(factory.selectedDate).format('MM-DD-YYYY');
        startDateFormatted = startDate.format('MM-DD-YYYY');

        if (!option.end && (moment(factory.selectedDate).isAfter(startDate))
          || startDateFormatted === selectedDateFormatted) {
          // uncomment this log for debugging purposes
          // console.log('1st condition')
          pushToArray = true;
        }

        if (option.end && (option.start === option.end) && (selectedDateFormatted === startDateFormatted)) {
          // uncomment this log for debugging purposes
          // console.log('2nd condition ' + selectedDateFormatted + ' ' + startDateFormatted)
          pushToArray = true;
        }

        if (option.end && (option.start !== option.end) && moment(factory.selectedDate).isBetween(startDate, endDate)) {
          // uncomment this log for debugging purposes
          // console.log('3rd condition')
          pushToArray = true;
        }

        // Show Enabled economy option
        if ((currentDay.day() === 6 || currentDay.day() === 0) && option.time) {
          // uncomment this log for debugging purposes
          // console.log('4th condition')
          pushToArray = triggeredBySelection ? pushToArray : true;
        }

        if (pushToArray) {
          deliveryDaysArr.push(option);
        }
      });

      item.deliveryDays = deliveryDaysArr;
      return item.deliveryDays.length;
    }

    function getDeliveryOptions (triggeredBySelection, daysToStart) {
      const pricingInfo = factory.selectedProduct.pricingInfo;
      const options = angular.copy(pricingInfo.deliveryOptions);
      const filterMethods = {
        'information': filterByDays.bind({ triggeredBySelection: triggeredBySelection, daysToStart: daysToStart }),
        'DKLetters': filterByDaysDKLetters.bind({ daysToStart, triggeredBySelection }),
        'paymentSlips': filterByDays.bind({ triggeredBySelection: triggeredBySelection, daysToStart: daysToStart }),
        'admail-letter': filterByDaysAdmail.bind(
          { triggeredBySelection: triggeredBySelection, daysToStart: daysToStart }),
        'admail-postcard': filterByDaysAdmail.bind(
          { triggeredBySelection: triggeredBySelection, daysToStart: daysToStart })
      };

      factory.deliveryOptions = (options || []).filter(filterMethods[Common.get('serviceType', getInformationCategory())])
        .filter(filterByAddressType)
        .filter(filterByDelivery)
        .filter(filterEmptyPostage)
        .map(appendDeliveryClass);
      // .map(changeTime); // to be triggerred for debugging
      return factory.deliveryOptions;
    }

    function getOldSettings (currentDate, daysToStart, deliveryDate) {
      let x, skipped, date, dateOnAWeekend, filteredDay, startDateIsSet, curDateOnAWeekend;
      factory.selectedDate = new Date(deliveryDate);
      getDeliveryOptions();

      for (x = daysToStart; ; x++) {
        date = angular.copy(currentDate);
        curDateOnAWeekend = checkIfOnWeekend(currentDate);
        date.setDate(date.getDate() + x);
        dateOnAWeekend = checkIfOnWeekend(date);
        filteredDay = checkIfHoliday(date);

        if (!filteredDay.length && !dateOnAWeekend && !startDateIsSet) {
          if ((curDateOnAWeekend || checkIfHoliday(currentDate).length) && !skipped) {
            skipped = true;
          } else {
            daysToStart = angular.copy(x);
            startDateIsSet = true;
            break;
          }
        }
      }

      return {
        daysToStart: daysToStart,
        daysToSelected: moment(deliveryDate).diff(moment(currentDate), 'day') + 1
      };
    }

    function getInformationCategory () {
      if (pnTopbar.market === 'DK') {
        return 'DKLetters';
      }
      return 'information';
    }

    function getStartSelectedDates () {
      let startPreDates;
      const product = Common.get('productDelivery', false);
      const currentDate = new Date();
      const startDate = angular.copy(currentDate); // start of selectable date
      const selectedDate = angular.copy(currentDate); // pre selected date
      const serviceType = Common.get('serviceType', getInformationCategory());

      // in preparation for other services
      const startPreMethods = {
        'information': startPreSelectSettings,
        'DKLetters': startPreselectDKLetterSettings,
        'paymentSlips': startPreSelectSettings,
        'admail-letter': startPreSelectAdmailSettings,
        'admail-postcard': startPreSelectAdmailSettings,
      };

      const checkLastDay = {
        'information': checkIfLastDayOfWeek,
        'DKLetters': checkIfLastDayOfWeek,
        'paymentSlips': checkIfLastDayOfWeek,
        'admail-letter': checkIfLastDayOfWeekAdmail,
        'admail-postcard': checkIfLastDayOfWeekAdmail,
      };

      factory.currentDate = moment(angular.copy(currentDate));

      if (!product) {
        checkLastDay[serviceType](currentDate);
        startPreDates = startPreMethods[serviceType](currentDate);
      } else {
        factory.selectedDate = new Date(product.deliveryDate);
        startPreDates = getOldSettings(currentDate, daysToStartFromCurrent, product.deliveryDate);
      }

      startDate.setDate(startDate.getDate() + startPreDates.daysToStart);
      selectedDate.setDate(selectedDate.getDate() + startPreDates.daysToSelected);

      return {
        startDate: startDate,
        selectedDate: selectedDate,
        showCalendar: true
      };
    }

    function setSelectedOption (options) {
      factory.deliveryDay = null;
      const deliveryOptions = {};
      const idArr = [];
      let preSelectId = null;

      options.forEach((item) => {
        idArr.push(item.id);
        deliveryOptions[item.id] = item.deliveryDays.filter((day) => {
          const dayIsValid = day.time ? !factory.checkTime(day) : true;
          return dayIsValid && !day.invalidOption;
        });
      });

      Object.keys(deliveryOptions).forEach((key) => {
        if (!deliveryOptions[key].length) {
          idArr.splice(idArr.indexOf(key), 1);
        }
      });

      if (idArr.length === 1) {
        preSelectId = Number(idArr[0]);
        factory.deliveryDay = deliveryOptions[preSelectId][0];
      }

      preSelectId = preSelectId ? preSelectId.toString() : preSelectId;

      return preSelectId;
    }

    function resetCalendarDates () {
      factory.currentDate = moment();
      factory.calendarDates = [{
        'date': factory.currentDate,
        'class': 'dp-current-date'
      }];
    }

    factory.getStartSelectedDates = getStartSelectedDates;
    factory.getHolidays = getHolidays;
    factory.getCalendarDates = getCalendarDates;
    factory.plotOptionDays = plotOptionDays;
    factory.setCurrentDate = setCurrentDate;
    factory.getCurrentDate = getCurrentDate;
    factory.addYear = addYear;
    factory.filterYear = filterYear;
    factory.checkTime = checkTime;
    factory.setSelectedOption = setSelectedOption;
    factory.getDeliveryOptions = getDeliveryOptions;
    factory.resetCalendarDates = resetCalendarDates;

    return factory;

  }

  angular.module('web2print.whereTo')
    .factory('distributionFactory', distributionFactory);
})();
